import { render, staticRenderFns } from "./CheckoutContactDetailsComponent.html?vue&type=template&id=b355fa66&scoped=true&"
import script from "./CheckoutContactDetailsComponent.js?vue&type=script&lang=js&"
export * from "./CheckoutContactDetailsComponent.js?vue&type=script&lang=js&"
import style0 from "./CheckoutContactDetailsComponent.scss?vue&type=style&index=0&id=b355fa66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b355fa66",
  null
  
)

export default component.exports